import type { IconSvgObject } from './types';

const PointingRight01Icon: IconSvgObject = [
  ["path", { d: "M16 4.5H21.5M19.5 2L22 4.5L19.5 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 20H4L6.31081 20.9985C7.78747 21.7056 10.6774 22.6732 12.0382 21.3211C14.1833 19.1895 14.576 16.2082 14.5 14.5H20.25C21.2165 14.5 22 13.7165 22 12.75C22 11.7835 21.2165 11 20.25 11L10 11L12.3287 8.78341C12.9689 8.05938 12.8628 6.96519 12.0947 6.36948C11.4556 5.87385 10.5466 5.87719 9.91137 6.3775L4.00268 11H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PointingRight01Icon;
